import { cx } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

interface LegalOrderedListProps extends ComponentPropsWithoutRef<'ol'> {
  readonly spacing?: 'single' | 'double';
  readonly indent?: 'single' | 'double';
  readonly children: ReactNode;
}

const LegalOrderedList = ({
  spacing = 'single',
  indent = 'single',
  children,
  className,
}: LegalOrderedListProps) => {
  return (
    <ol
      className={cx(
        {
          '[&>li]:mb-4': spacing === 'double',
          'ml-4': indent === 'single',
          'ml-12': indent === 'double',
        },
        className,
      )}
    >
      {children}
    </ol>
  );
};

export default LegalOrderedList;
